import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '000000';

@Pipe({ name: 'axisInputNumberParsePipe' })
export class AxisInputNumberParsePipe implements PipeTransform {
  constructor() {}

  transform(value: string, settings): string {
    if (value || parseInt(value, 10) === 0) {
      const thousandsSeparator = settings.thousands_separator
        ? settings.thousands_separator
        : ',';
      if (settings.fraction_size) {
        let integer,
          fraction = '';
        integer = value
          .toString()
          .replace(settings.prefix, '')
          .replace(settings.suffix, '');
        integer = integer
          .toString()
          .split(thousandsSeparator)
          .join('');
        fraction = integer.split(settings.decimal_separator)[1]
          ? integer.split(settings.decimal_separator)[1]
          : '';
        fraction =
          settings.fraction_size > 0
            ? settings.decimal_separator +
              (fraction + (settings.noTrailingZeros ? '' : PADDING)).substring(0, settings.fraction_size)
            : '';
        integer = integer.split(settings.decimal_separator)[0];
        return integer + (fraction && fraction !== settings.decimal_separator ? fraction : '');
      }

      let integerValue = value
        .toString()
        .replace(settings.prefix, '')
        .replace(settings.suffix, '');
      integerValue = integerValue
        .toString()
        .split(thousandsSeparator)
        .join('');
      let finalValue;
      if (settings.round === 0 || settings.round) {
        finalValue =
          settings.round === 0
          ? Math.round(Number(integerValue))
          : this.decimalAdjust('round', integerValue, settings.round);
      } else if (settings.floor === 0 || settings.floor) {
        finalValue =
          settings.floor === 0
          ? Math.floor(Number(integerValue))
          : this.decimalAdjust('floor', integerValue, settings.floor);
      } else if (settings.ceil === 0 || settings.ceil) {
        finalValue =
          settings.ceil === 0
          ? Math.ceil(Number(integerValue))
          : this.decimalAdjust('ceil', integerValue, settings.ceil);
      } else {
        finalValue = integerValue;
      }
      return finalValue;
    } else {
      return '';
    }
  }

  decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (
      value === null ||
      isNaN(value) ||
      !(typeof exp === 'number' && exp % 1 === 0)
    ) {
      return NaN;
    }

    if (value < 0) {
      return -this.decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }
}
